// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1f-o";
export var animationRelative = "_1f-n";
export var backdropBlur = "_1f-0";
export var detailLabelCell = "_1f-10";
export var detailTable = "_1f-z";
export var detailValueCell = "_1f-11";
export var docIconBox = "_1f-19";
export var docTypeRow = "_1f-14";
export var docTypeRowInner = "_1f-15";
export var dropdownMatchDatePicker = "_1f-1";
export var fileUploadSpin = "_1f-h";
export var gorgiasOpenButton = "_1f-13 _1f-b";
export var gorgiasTicketCard = "_1f-12";
export var heroModalFooterButton = "_1f-16";
export var hiddenContainer = "_1f-m";
export var maxWidthContainer = "_1f-17";
export var modalContentBody = "_1f-8";
export var modalHeaderImage = "_1f-3";
export var modalImageLabel = "_1f-5";
export var modalImageOverlay = "_1f-4";
export var modalImageSubtitle = "_1f-7";
export var modalImageTitle = "_1f-6";
export var modalImageWrapper = "_1f-2";
export var modalStickyFooter = "_1f-9";
export var removeButton = "_1f-c";
export var sidebarColumn = "_1f-18";
export var spinner = "_1f-g";
export var timelineLine = "_1f-w";
export var timelineLineBlack = "_1f-y _1f-w";
export var timelineLineGray = "_1f-x _1f-w";
export var timelineLineHeight = "_1f-v";
export var tlDotActivate = "_1f-s";
export var tlDotActivateAnim = "_1f-r";
export var tlDotHide = "_1f-q";
export var tlDotHideAnim = "_1f-p";
export var tlLineActivate = "_1f-u";
export var tlLineActivateAnim = "_1f-t";
export var uploadHint = "_1f-l";
export var uploadIconBox = "_1f-i";
export var uploadLabel = "_1f-k";
export var uploadText = "_1f-j";
export var uploadZone = "_1f-d";
export var uploadZoneCursorDefault = "_1f-f";
export var uploadZoneCursorPointer = "_1f-e";
export var uploadedFileRow = "_1f-a";
export var viewButton = "_1f-b";